/**
 * Created by akirilyuk.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/ticketItemView.tmpl"),
        TicketListItemView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketListItemView = Marionette.ItemView.extend({
            template: template,
            className: 'ticket-view',
            region:{
                ticketDetail:".ticket-item-detail"
            },
            ui: {
               "ticketId": ".ticket-item-id",
               "ticketSolved": ".ticket-item-solved",
               "ticketDetail": ".ticket-item-detail",
                "ticketContainer": ".ticket-container"
            },
            events: {
                 click: "_onClick"
            },
            
            initialize: function(){
                this.ticketTabChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.TICKET_TAB);

            },

            _onClick: function(){
                this.ticketTabChannel.vent.trigger("TicketTabController::ticket:display",{model:this.model});
            },

            setSelected: function(id){
                if (id && this.model.get("id") === id) {
                    if(this.isSelected){
                        this._unSelect();
                    }else{
                        this._select();
                    }
                }
                else {
                    this._unSelect();
                }
            },

            _unSelect: function () {
                this.ui.ticketContainer.removeClass("is-selected");
                this.isSelected = false;
            },

            _select: function () {
                this.ui.ticketContainer.addClass("is-selected");
                this.isSelected = true;
            }
        });
});
    return TicketListItemView;
});
